module.exports = __webpack_public_path__ + "img/file-icon.f89179ba.png";